export default {
    AMOUNT:'Investment amount',
    VALUATION:'Valuation',
    ISSUED_DATE:'Issued date',
    PLACEHOLDER_NUMBER:'Enter a number',
    PLACEHOLDER_DATE:'dd/mm/yyyy'
}